/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.Booth = function( xml, idx, jsonObject) {
    var str;
    
    var bth = {
		index: idx,
        number: "",
        status: "0",
        exhibitorIndex: "",
        areaF: "",
        areaM: "",
        dimF: "",
        dimM: "",
        flyout: "",
        graphic : null
    };
    
    if( xml !== null) {
        bth.number = xml.getAttribute("n");
        bth.status = xml.getElementsByTagName("ST")[0].getAttribute("s");
        bth.exhibitorIndex = xml.getAttribute("cIX");
		
		bth.areaF = xml.getAttribute("a");
		bth.areaM = xml.getAttribute("aO");
        bth.flyout = xml.getAttribute("fo");
		
		if( bth.flyout) {
				// VALIDATE ?! delete any script tags, and ??  link? 
			str = bth.flyout.toLowerCase();

			if( str.indexOf( "script") !== -1 ||
				str.indexOf( "<style") !== -1 ||
				str.indexOf( "!--") !== -1 ) {

				bth.flyout = "INVALID CONTENT";
			}

			bth.flyout = bth.flyout.trim().replace( /\n/g, "<br/>");
		}
		
        bth.dimF = xml.getAttribute("s");
        bth.dimM = xml.getAttribute("sO");   

    }
    if (jsonObject != null) {

        idx = jsonObject.boothIndex;
        bth.number = jsonObject.boothNumber;
        bth.status = jsonObject.status;
        bth.exhibitorIndex = jsonObject.exhibitorIndex;

        bth.areaF = jsonObject.areaSqFt;
        bth.areaM = jsonObject.areaSqM;

        bth.dimF = jsonObject.dimSqFt;
        bth.dimM = jsonObject.dimSqM;

        bth.flyout = jsonObject.flyout;
        
        if (bth.flyout) {
            // VALIDATE ?! delete any script tags, and ??  link? 
            str = bth.flyout.toLowerCase();

            if (str.indexOf("script") !== -1 ||
                str.indexOf("<style") !== -1 ||
                str.indexOf("!--") !== -1) {

                bth.flyout = "INVALID CONTENT";
            }

            bth.flyout = bth.flyout.trim().replace(/\n/g, "<br/>");
        }
       
        
    }
    return bth;
};